__turbopack_context__.v({
  "alignLeft": "Testimonials-module__REfjxa__alignLeft",
  "breadcrumbWrap": "Testimonials-module__REfjxa__breadcrumbWrap",
  "breakdownCount": "Testimonials-module__REfjxa__breakdownCount",
  "breakdownFill": "Testimonials-module__REfjxa__breakdownFill",
  "breakdownList": "Testimonials-module__REfjxa__breakdownList",
  "breakdownRow": "Testimonials-module__REfjxa__breakdownRow",
  "breakdownStar": "Testimonials-module__REfjxa__breakdownStar",
  "breakdownTrack": "Testimonials-module__REfjxa__breakdownTrack",
  "exploreBtn": "Testimonials-module__REfjxa__exploreBtn",
  "exploreSection": "Testimonials-module__REfjxa__exploreSection",
  "galleryHeader": "Testimonials-module__REfjxa__galleryHeader",
  "galleryMarquee": "Testimonials-module__REfjxa__galleryMarquee",
  "galleryMarqueeItem": "Testimonials-module__REfjxa__galleryMarqueeItem",
  "gallerySection": "Testimonials-module__REfjxa__gallerySection",
  "galleryTrack": "Testimonials-module__REfjxa__galleryTrack",
  "page": "Testimonials-module__REfjxa__page",
  "reviewsHeader": "Testimonials-module__REfjxa__reviewsHeader",
  "reviewsLayout": "Testimonials-module__REfjxa__reviewsLayout",
  "reviewsSection": "Testimonials-module__REfjxa__reviewsSection",
  "reviewsSliderWrap": "Testimonials-module__REfjxa__reviewsSliderWrap",
  "scrollGallery": "Testimonials-module__REfjxa__scrollGallery",
  "shareStoryBtn": "Testimonials-module__REfjxa__shareStoryBtn",
  "shareStoryCopy": "Testimonials-module__REfjxa__shareStoryCopy",
  "shareStoryInner": "Testimonials-module__REfjxa__shareStoryInner",
  "shareStorySection": "Testimonials-module__REfjxa__shareStorySection",
  "sideNext": "Testimonials-module__REfjxa__sideNext",
  "sidePrev": "Testimonials-module__REfjxa__sidePrev",
  "slickSlide": "Testimonials-module__REfjxa__slickSlide",
  "statCard": "Testimonials-module__REfjxa__statCard",
  "statIcon": "Testimonials-module__REfjxa__statIcon",
  "statIconDefault": "Testimonials-module__REfjxa__statIconDefault",
  "statIconStar": "Testimonials-module__REfjxa__statIconStar",
  "statLabel": "Testimonials-module__REfjxa__statLabel",
  "statValue": "Testimonials-module__REfjxa__statValue",
  "statsGrid": "Testimonials-module__REfjxa__statsGrid",
  "statsHeader": "Testimonials-module__REfjxa__statsHeader",
  "statsSection": "Testimonials-module__REfjxa__statsSection",
  "summaryCard": "Testimonials-module__REfjxa__summaryCard",
  "summaryMeta": "Testimonials-module__REfjxa__summaryMeta",
  "summaryScore": "Testimonials-module__REfjxa__summaryScore",
  "summaryStars": "Testimonials-module__REfjxa__summaryStars",
  "summaryTop": "Testimonials-module__REfjxa__summaryTop",
  "tabBtn": "Testimonials-module__REfjxa__tabBtn",
  "tabBtnActive": "Testimonials-module__REfjxa__tabBtnActive",
  "tabsRow": "Testimonials-module__REfjxa__tabsRow",
});
